import React, { useEffect, useState } from 'react';

export const ThemeContext = React.createContext<any>({});

export function useThemeManager() {
  const [isDarkMode, setIsDarkMode] = useState<boolean>(false);
  const [isLeftHanded, setIsLeftHanded] = useState<boolean>(false);

  useEffect(() => {
    document.body.setAttribute('data-theme', isDarkMode ? 'dark' : 'light');
  }, [isDarkMode]);

  return {
    isDarkMode,
    setIsDarkMode,
    isLeftHanded,
    setIsLeftHanded,
  };
}

export function useTheme() {
  return React.useContext(ThemeContext);
}
